import {
  type FlowExportTextToBucketBlockConfig,
  FlowExportTextToBucketBlockConfigSchema,
  FlowProducedType,
} from 'flow-schema';

import { ExportTextToBucketFormFields } from './FormFields';
import { exportTextToBucketDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const exportTextToBucketConfig: BlockConfigProps<FlowExportTextToBucketBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'exportData',
  defaultConfig: {
    patient: {
      sourceBlockName: '',
      consumesType: FlowProducedType.Patient,
    },
    source: '',
  },
  configFields: {
    schema: FlowExportTextToBucketBlockConfigSchema,
    FormFields: ExportTextToBucketFormFields,
  },
  documentationMarkdown: exportTextToBucketDocumentationMarkdown,
};
